export default __webpack_public_path__ + "static/facebook_light-91c1215456f1a9d32e583fbf05b4424c.svg";